export const featureNames = {
  useMonerisDirect3ds: 'use-moneris-direct-3DS',
  autoPopulateEstimateData: 'auto-populate-estimate-data',
  useFedexNewRegistration: 'use-fedex-new-registration',
  soldToFeature: 'sold-to-feature',
  updatesPreferences: 'updates-preferences',
};
